import Select from 'react-select';
/**
 * WordPress dependencies
 */
const { useState } = wp.element;
const { useSelect } = wp.data;

const TermSelect = (props) => {
	const { taxonomy } = props;
	const [searchKeyword, setSearchKeyword] = useState('');

	const params = {
		per_page: 10,
		search: searchKeyword
	};

	const { data, isRequesting } = useSelect(
		(select) => {
			return {
				data: select('core').getEntityRecords('taxonomy', taxonomy, params),
				isRequesting: select('core/data').isResolving('core', 'getEntityRecords', ['taxonomy', taxonomy, params])
			};
		},
		[taxonomy, searchKeyword]
	);

	const options =
		data?.map((term) => ({
			label: `${term.name} (ID: ${term.id})`,
			value: term.id
		})) || [];

	return (
		<div>
			<Select
				classNamePrefix='conditional-blocks-select'
				className='conditional-blocks-select-container'
				isSearchable
				isLoading={isRequesting}
				options={options}
				onInputChange={(val) => setSearchKeyword(val)}
				{...props}
			/>
		</div>
	);
};

export default TermSelect;
